import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
    selector: 'app-protection-matters-ifp',
    templateUrl: './protection-matters-ifp.component.html',
    styleUrls: ['./protection-matters-ifp.component.scss']
})
export class ProtectionMattersIfpComponent implements OnInit {

    constructor(
        private meta: Meta,
        private titleService: Title,
        private seoService: SeoServiceService
    ) { }

    ngOnInit(): void {
        this.seoService.createLinkForCanonicalURL();
        this.titleService.setTitle('Why Protection Matters for Interactive Flat Panels | Virsa');
        this.meta.updateTag({
            name: 'description',
            content: 'Learn how to extend the life of Interactive Flat Panels with proper protection. Discover why schools across India trust Virsa for durable smart classroom solutions.'
        });
        this.meta.updateTag({
            name: 'keywords',
            content: 'Interactive Flat Panel for Schools, IFP for Schools India, Smart Classroom Solutions India, Best IFP for Schools, Smart Classroom Provider India, Digital Classroom India, Virsa IFP, IFP Protection'
        });
    }

}
